import { render, staticRenderFns } from "./TableDataBase.vue?vue&type=template&id=38bd19a5&scoped=true&lang=pug"
import script from "./TableDataBase.vue?vue&type=script&lang=ts"
export * from "./TableDataBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd19a5",
  null
  
)

export default component.exports